export default __webpack_public_path__ + "static/lozenge-icon-dont-light-90466580416a7e23ef108987227f824767df12da9c0f53553cc1d13b266ff66c.png";